// SubscribersList.js

import React from "react";
import { useEffect, useReducer} from "react";
import { Text, View } from "react-native";
import { stateReducer } from "components/helpers/stateReducer";
import Button from "components/Partials/Buttons";
import SubscriberRow from "components/Views/Subscribers/SubscriberRow";

const SubscribersList = () => {
	const _theme = window.main.theme;

	const newCustomer = ()=>{
		console.log(1);
		const newCustomerObj = {
			organization_id: 0,
			name: "",
			shortname: "",
			shortname: "",
			public_phone: "",
			pulic_email: "",
			public_website: "",
			public_facebook: "",
			public_instagram: "",
		};
		console.log(2);
		window.main.lib.setCurrentView(`/organization/view/0`, newCustomerObj);
	};

	const [homeState, homeSetState] = useReducer(stateReducer, {
		customersData: [],
		customersLoadedDate: new Date(),
		initComplete: false,
	});

	const fetchCustomers = async () => {
		try {
			window.main.lib.setLoadingState(true);
			const customersResult = await window.main.axios.get(window.main.api.organizations);
			if (!!customersResult.data && !!customersResult.data.length) {
				homeSetState([
					{key:"initComplete",		type:"boolean",	initComplete: true},
					{key:"customersData",		type:"array",	customersData: customersResult.data},
					{key:"customersLoadedDate",	type:"date",	customersLoadedDate: new Date()},
				]);
			}
			if (!!homeState.initComplete) {
				window.main.lib.setLoadingState(false);
			}
		} catch (error) {
			console.log("Error fetching Patients data:", error);
			window.main.lib.setStatusState(window.main.lib.parseErrorMessage(error));
			window.main.lib.setLoadingState(false);
		}
	};

	const init = async ()=>{
		if (!!homeState.initComplete) {
			homeSetState([
				{key:"initComplete",	type:"boolean",	initComplete: false},
			]);
		}
		await fetchCustomers();
		window.main.lib.setLoadingState(false);
	};

	useEffect(()=>{
		init();
	},[]);

	///////////////////////////
	// Main Component Return //
	///////////////////////////
	return (
		<View style={{..._theme.container,flexShrink:1,borderWidth:0,paddingVertical:14,paddingHorizontal:(_theme.responsiveKey==="phone"?10:0),maxWidth:(window.main.platform_os!=="web"?400:_theme.respWidth)}}>

			<View style={{..._theme.containerLiner,flexShrink:1,marginBottom:30}}>
				<View style={{..._theme.containerTitle}}>
					<View style={{display:"flex",flexDirection:"row",flexGrow:1}}>
						<Text style={_theme.containerTitleText}>Subscribers: ({homeState.customersData.length})</Text>
						<Button type="link" ficon="refresh-ccw" text={window.main.platform_os==="web"?"Refresh":""} style={{marginTop:0,marginBottom:0,marginHorizontal:0,marginRight:2,paddingVertical:0,height:22,...(window.main.platform_os==="web"?{paddingLeft:20,paddingRight:5}:{width:28,paddingHorizontal:0,paddingLeft:4,paddingRight:0})}} textStyle={{fontSize:14}} iconSize={14} onPress={fetchCustomers} />
					</View>
					<Button type="primary" ficon="plus" text={"Add Subscriber"} style={{marginTop:0,marginBottom:0,marginHorizontal:0,marginRight:2,paddingVertical:0,height:28,...(window.main.platform_os==="web"?{paddingLeft:20,paddingRight:5}:{width:28,paddingHorizontal:0,paddingLeft:4,paddingRight:0})}} onPress={newCustomer} />
				</View>
				<View style={{flexDirection:"column",justifyContent:"flex-start",alignItems:"flex-start",backgroundColor:_theme.colors.mode.containerBackgroundColor,borderColor:_theme.colors.mode.containerBorderColor}}>

					<View style={{display:"flex",flexDirection:"row",justifyContent:"flex-start",alignItems:"flex-start",flexGrow:1,flexShrink:1,alignSelf:"stretch",position:"relative",backgroundColor:_theme.colors.mode.containerBorderColor}}>
						<View style={{flexDirection:"row",justifyContent:"stretch",alignItems:"flex-end",padding:5,flexBasis:40,flexGrow:0}}>
							<Text style={{color:_theme.colors.mode.inputTextColor,fontWeight:"600"}}>&nbsp;</Text>
						</View>
						<View style={{flexDirection:"row",justifyContent:"stretch",alignItems:"flex-start",padding:5,flexBasis:300,flexGrow:1}}>
							<Text style={{color:_theme.colors.mode.inputTextColor,fontWeight:"600"}}>Organization Name</Text>
						</View>
						<View style={{flexDirection:"row",justifyContent:"stretch",alignItems:"flex-start",padding:5,flexBasis:250,flexGrow:0}}>
							<Text style={{color:_theme.colors.mode.inputTextColor,fontWeight:"600"}}>Public Email</Text>
						</View>
						<View style={{flexDirection:"row",justifyContent:"stretch",alignItems:"flex-start",padding:5,flexBasis:150,flexGrow:0}}>
							<Text style={{color:_theme.colors.mode.inputTextColor,fontWeight:"600"}}>Public Phone</Text>
						</View>
						<View style={{flexDirection:"row",justifyContent:"stretch",alignItems:"flex-start",padding:5,flexBasis:250,flexGrow:0}}>
							<Text style={{color:_theme.colors.mode.inputTextColor,fontWeight:"600"}}>Public Website</Text>
						</View>
						<View style={{flexDirection:"row",justifyContent:"stretch",alignItems:"flex-start",padding:5,flexBasis:100,flexGrow:0}}>
							<Text style={{color:_theme.colors.mode.inputTextColor,fontWeight:"600"}}># Locations</Text>
						</View>
						<View style={{flexDirection:"row",justifyContent:"stretch",alignItems:"flex-start",padding:5,flexBasis:80,flexGrow:0}}>
							<Text style={{color:_theme.colors.mode.inputTextColor,fontWeight:"600"}}># Doctors</Text>
						</View>
						<View style={{flexDirection:"row",justifyContent:"stretch",alignItems:"flex-start",padding:5,flexBasis:80,flexGrow:0}}>
							<Text style={{color:_theme.colors.mode.inputTextColor,fontWeight:"600"}}># Techs</Text>
						</View>
						<View style={{flexDirection:"row",justifyContent:"stretch",alignItems:"flex-start",padding:5,flexBasis:80,flexGrow:0}}>
							<Text style={{color:_theme.colors.mode.inputTextColor,fontWeight:"600"}}># Staff</Text>
						</View>
						<View style={{flexDirection:"row",justifyContent:"stretch",alignItems:"flex-start",padding:5,flexBasis:80,flexGrow:0}}>
							<Text style={{color:_theme.colors.mode.inputTextColor,fontWeight:"600"}}>Status</Text>
						</View>
					</View>

					{homeState.customersData.map((customerObj, index)=>{
						return (
							<SubscriberRow key={customerObj.organization_id} rowIndex={index} customerObj={customerObj} />
						);
					})}

				</View>
			</View>

		</View>
	);
};

export default SubscribersList;
